import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { FALLBACK_LOCALE, SUPPORTED_LOCALES } from '@repo/i18n/supported-locales';
import { CookieConsentBanner } from '@repo/ui/components/cookie-consent-banner';

export const Route = createFileRoute('/$pathLocale')({
  component: RouteComponent,
  beforeLoad: (ctx) => {
    if (!SUPPORTED_LOCALES.includes(ctx.params.pathLocale)) {
      throw redirect({ to: '/$pathLocale', params: { pathLocale: FALLBACK_LOCALE } });
    }

    ctx.context.i18n.changeLanguage(ctx.params.pathLocale);
  },
});

function RouteComponent() {
  const { t } = useTranslation(['common']);
  const { pathLocale } = Route.useParams();

  return (
    <>
      <Outlet />
      <CookieConsentBanner
        privacyPolicyLink={
          <a
            className="text-sm underline"
            href={`https://wekapp.com/${pathLocale}/privacy-cookie-policy`}
            target="_blank"
          >
            {t('common:privacy-policy.privacy-cookie-policy')}
          </a>
        }
      />
    </>
  );
}
